import { HookType, PhaseName } from "utils/hooks";
import Typography from "ds/components/Typography";
import Card from "ds/components/Card";

import { ContextHook } from "../../types";
import ContextHooksList from "../ContextHooksList";
import StackHooksList from "../StackHooksList";

type PhaseHooksProps = {
  name: PhaseName;
  type: HookType;
  contextHooks: ContextHook[];
  stackHooksIds: string[];
  allTextCommandsById: Record<string, string>;
  isDragActive: boolean;
};

const PhaseHooks = ({
  name,
  type,
  contextHooks,
  stackHooksIds,
  isDragActive,
  allTextCommandsById,
}: PhaseHooksProps) => {
  const contextHooksList = <ContextHooksList type={type} hooks={contextHooks} />;
  const stackHooksList = (
    <StackHooksList
      name={name}
      isDragActive={isDragActive}
      type={type}
      hooksIds={stackHooksIds}
      allTextCommandsById={allTextCommandsById}
    />
  );
  return (
    <Card contentGap="large">
      <Typography tag="p" color="secondary" variant="p-t7" transform="uppercase">
        {type === "before" ? "Before" : "After"}
      </Typography>
      {type == "before" ? (
        <>
          {contextHooksList}
          {stackHooksList}
        </>
      ) : (
        <>
          {stackHooksList}
          {contextHooksList}
        </>
      )}
    </Card>
  );
};

export default PhaseHooks;
